import React, { Component } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { Replay as Reload, AddCircleOutline as Add } from "@material-ui/icons";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";

import SearchButton from "components/ui/searchbutton/SearchButton";
import PointsGrid from "./PointsGrid";
import DialogPoint from "./DialogPoint";
import DialogConfirm from "./DialogConfirm";

import { commonJs } from "common/common";
import { ERRORS, LABELS, NOTIFY, ROLES, SUCCESS_MSG } from "common/consts";
import { PAGE_ACTIONS } from "actions/PageActions";
import { API_Map } from "apihandler/Map";

import "./pointtab.css";

class PointsTab extends Component {
  pointSearch = (e) => {
    this._pointsGrid.pointSearch(e.target.value.trim());
  };

  deletePoint = (id, name = null) => {
    if (!name) {
      let self = this;
      self.props.toggleLoading({
        loadingPopover: true,
      });
      API_Map.deletePoint("/" + id)
        .then((res) => {
          if (res.Result === 200) {
            commonJs.showNotify(
              self.props,
              NOTIFY.SUCCESS,
              SUCCESS_MSG.POINT_DELETED_SUCCESSFULLY,
              <button className="snackbar-btn">{LABELS.DISMISS}</button>
            );
            self._dialogConfirm.toggleConfirmDialog(id, name);
            self.props.toggleLoading({
              loadingPopover: false,
            });
            self.reloadPoints();
          } else {
            console.log("Delete Point Error: ", res.Reason);
            commonJs.showNotify(
              self.props,
              NOTIFY.ERROR,
              ERRORS.POINT_NOT_DELETED,
              <button className="snackbar-btn">{LABELS.DISMISS}</button>
            );
            self.props.toggleLoading({
              loadingPopover: false,
            });
          }
        })
        .catch((err) => {
          console.log("Delete Point Error: ", err);
          commonJs.showNotify(
            self.props,
            NOTIFY.ERROR,
            ERRORS.ZONE_NOT_DELETED,
            <button className="snackbar-btn">{LABELS.DISMISS}</button>
          );
          self.props.toggleLoading({
            loadingPopover: false,
          });
        });
    } else {
      this._dialogConfirm.toggleConfirmDialog(id, name);
    }
  };

  deleteAllPoints = () => {
    this._dialogConfirm.toggleConfirmDialog("");
  };

  reloadPoints = () => {
    this._pointsGrid.reloadPoints();
  };

  render() {
    const { role } = this.props.loginReducer;
    return (
      <div className="pointsTab">
        <ul>
          <li>
            <SearchButton
              id="pointSearch"
              placeholder="Search By Point Name"
              buttonClass="pad5 iconButton searchBtn"
              inputClass="SearchInput"
              iconwidth="18"
              iconheight="18"
              onChange={this.pointSearch}
            />
          </li>
          <li className="poiBtn">
            <Tooltip title="Reload" placement="bottom">
              <IconButton onClick={this.reloadPoints}>
                <Reload />
              </IconButton>
            </Tooltip>
          </li>
          {role !== ROLES.SUB_USER && (
            <li className="poiBtn">
              <Tooltip title="Add Point" placement="bottom">
                <IconButton
                  onClick={() =>
                    this._pointDialog.toggleAddPointDialog({ add: true })
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
            </li>
          )}
          {/* <li className="poiBtn">
            <Tooltip title="Delete" placement="bottom">
              <IconButton onClick={this.deleteAllPoints}>
                <Delete />
              </IconButton>
            </Tooltip>
          </li> */}
        </ul>

        <PointsGrid
          childRef={(ref) => (this._pointsGrid = ref)}
          toggleAddPointDialog={(point) =>
            this._pointDialog.toggleAddPointDialog(point)
          }
          deletePoint={this.deletePoint}
          updateMapRegion={this.props.updateMapRegion}
        />

        <DialogPoint
          childRef={(ref) => (this._pointDialog = ref)}
          updateMapRegion={this.props.updateMapRegion}
          reloadPoints={this.reloadPoints}
          toggleAddPointDialog={(point) =>
            this._pointDialog.toggleAddPointDialog(point)
          }
        />

        <DialogConfirm
          childRef={(ref) => (this._dialogConfirm = ref)}
          onOk={this.deletePoint}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginReducer: state.loginReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoading: (values) => {
      dispatch({
        type: PAGE_ACTIONS.SET_POPOVER_LOADING,
        values,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(PointsTab));
